import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Button } from 'semantic-ui-react';
import { ObjectPropsPropType } from '../../services/proptypes';
import Call from '../Call';
import Email from '../Email';
import Location from '../Location';
import './ContactRail.css';
var ContactRail = /*#__PURE__*/function (_React$Component) {
  _inherits(ContactRail, _React$Component);
  var _super = _createSuper(ContactRail);
  function ContactRail() {
    _classCallCheck(this, ContactRail);
    return _super.apply(this, arguments);
  }
  _createClass(ContactRail, [{
    key: "renderCallToAction",
    value: function renderCallToAction(type, props) {
      var _this$props = this.props,
        buttonColor = _this$props.buttonColor,
        iconsOnly = _this$props.iconsOnly;
      var manifestation = iconsOnly ? 'icon' : 'button';
      if (type === 'call') {
        return /*#__PURE__*/React.createElement(Call, _extends({
          className: "contact-rail-item",
          key: type,
          as: manifestation,
          buttonColor: buttonColor,
          showIcon: true
        }, props));
      }
      if (type === 'location') {
        return /*#__PURE__*/React.createElement(Location, _extends({
          className: "contact-rail-item",
          key: type,
          as: manifestation,
          buttonText: iconsOnly ? '' : 'Find us on Google Maps',
          buttonColor: buttonColor
        }, props));
      }
      if (type === 'email') {
        return /*#__PURE__*/React.createElement(Email, _extends({
          className: "contact-rail-item",
          key: type,
          as: manifestation,
          buttonColor: buttonColor,
          showIcon: true
        }, props));
      }
      return /*#__PURE__*/React.createElement("div", null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props2 = this.props,
        vertical = _this$props2.vertical,
        items = _this$props2.items,
        grouped = _this$props2.grouped;
      return grouped ? /*#__PURE__*/React.createElement(Button.Group, {
        vertical: vertical,
        style: {
          borderRadius: '0em'
        }
      }, items.map(function (_ref) {
        var type = _ref.type,
          props = _ref.props;
        return _this.renderCallToAction(type, props);
      })) : /*#__PURE__*/React.createElement("div", null, vertical ? items.map(function (_ref2) {
        var type = _ref2.type,
          props = _ref2.props;
        return /*#__PURE__*/React.createElement("div", {
          key: type,
          style: {
            marginBottom: '0.25em'
          }
        }, _this.renderCallToAction(type, props));
      }) : items.map(function (_ref3) {
        var type = _ref3.type,
          props = _ref3.props;
        return _this.renderCallToAction(type, props);
      }));
    }
  }]);
  return ContactRail;
}(React.Component);
export { ContactRail as default };
ContactRail.defaultProps = {
  buttonColor: 'primary',
  circular: false,
  grouped: false,
  iconsOnly: false,
  vertical: false
};